import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { trackSubscriptionInGaAndOptimizely } from '@tracking';
import { SubscribeUserParams, subscribeUser } from '@utils/backend-api/subscribe';

const useSubscribeUser = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: SubscribeUserParams) => subscribeUser(params),
    {
      onSuccess: (data) => {
        trackSubscriptionInGaAndOptimizely(data);
      },
      onError: (error: { message: string; redirect_to?: string }) => {
        toast.error(error.message);
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useSubscribeUser;
